import { render, staticRenderFns } from "./club-feature-cost-text.vue?vue&type=template&id=10c5f3c5&scoped=true"
import script from "./club-feature-cost-text.vue?vue&type=script&lang=ts"
export * from "./club-feature-cost-text.vue?vue&type=script&lang=ts"
import style0 from "./club-feature-cost-text.vue?vue&type=style&index=0&id=10c5f3c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c5f3c5",
  null
  
)

export default component.exports